import "./screen-container.css";
export const ScreenContainer = ({
  children,
  title = null,
  subtitle = null,
}: any) => {
  return (
    <div className="screen-container">
      {title && <h3 className="title-screen">{title}</h3>}
      {title && <h4 className="subtitle-screen">{subtitle}</h4>}
      {children}
    </div>
  );
};
